import React from 'react';

export type SellerAccountTypeWire = 'Personal' | 'Corporate';

export interface SellerTypeBadgeProps {
  accountType?: SellerAccountTypeWire | null;
  className?: string;
  compact?: boolean;
  /** Overrides default short label (e.g. Kurumsal Satıcı on detail pages). */
  detailLabel?: string;
}

const SellerTypeBadge: React.FC<SellerTypeBadgeProps> = ({
  accountType,
  className = '',
  compact = false,
  detailLabel,
}) => {
  if (accountType !== 'Corporate' && accountType !== 'Personal') {
    return null;
  }

  const isCorporate = accountType === 'Corporate';
  const label = detailLabel ?? (isCorporate ? 'Kurumsal' : 'Bireysel');

  return (
    <span
      className={`badge ${isCorporate ? 'text-bg-primary' : 'text-bg-secondary'} d-inline-flex align-items-center ${
        compact ? 'gap-1' : 'gap-1 px-2 py-1'
      } ${className}`.trim()}
      aria-label={isCorporate ? 'Kurumsal satıcı' : 'Bireysel satıcı'}
    >
      <i className={`fas ${isCorporate ? 'fa-building' : 'fa-user'}`} aria-hidden />
      <span className={compact ? 'small' : undefined}>{label}</span>
    </span>
  );
};

export default SellerTypeBadge;
